import type { InvoiceExtractionOut, InvoiceLinkOut } from '@/api/invoices';

/** Invoice fields a practitioner must capture before an attached invoice
 *  counts as "complete". Just the tax amount (`tax_shown`) for now;
 *  extend this list as the documentation bar rises. */
export const REQUIRED_INVOICE_FIELDS = ['tax_shown'] as const;

function isFilled(v: unknown): boolean {
  if (v === null || v === undefined) return false;
  if (typeof v === 'string') return v.trim() !== '';
  return true;
}

/** True iff there is at least one attached invoice AND every attached
 *  invoice has all `REQUIRED_INVOICE_FIELDS` filled. The document-level
 *  extraction (label-first flow) wins over the legacy per-link fact when
 *  present — same precedence the chip's preview uses. */
export function requiredInvoiceFieldsComplete(
  links: InvoiceLinkOut[] | undefined,
  extractions?: Map<string, InvoiceExtractionOut>,
): boolean {
  if (!links || links.length === 0) return false;
  return links.every((link) => {
    const source: Record<string, unknown> =
      extractions?.get(link.source_document_id) ?? link;
    return REQUIRED_INVOICE_FIELDS.every((field) => isFilled(source[field]));
  });
}
